/**
 * @description service
 * @media_type string, 资源类型
 * const MEDIA_TYPE_AUDIO = 'audio';
 * const MEDIA_TYPE_IMAGE = 'image';
 * const MEDIA_TYPE_IMAGE_FULLTEXT = 'imagefulltext';
 * const MEDIA_TYPE_IMAGE_WALL = 'imagewall';
 * const MEDIA_TYPE_IMAGE_WEIKE = 'imageweike';
 * const MEDIA_TYPE_VIDEO = 'video';
 * const MEDIA_TYPE_VIDEO_WEIKE = 'videoweike';
 * const MEDIA_TYPE_DOC_WEIKE = 'docweike';
 * const MEDIA_TYPE_PIC_WEIKE = 'picweike';
 * const MEDIA_TYPE_AI_LOG_FILE = 'ailogfile';
 * const MEDIA_TYPE_GRAFFITI = 'graffiti';  //涂鸦数据
 */

/**
 * @media_type string, 资源类型
 * @id_prefix	是	对象前缀
 * const ID_PREFIX_ENTERPRISE = 'enterprise';
 * const ID_PREFIX_SESSION = 'session';
 * const ID_PREFIX_STUDENT = 'student';
 * const ID_PREFIX_TEACHER = 'teacher';
 * const ID_PREFIX_HELPCENTER = 'helpcenter';
 * @id	否	对象ID
 * @ext	是	文件后缀名
 * @return {
 * "error_code": 0,
 * "error_message": "",
 *  "data": {
 *      "sp": 1, // 服务提供商，1. 百度；2. AWS ,
 *      "path": "docweike/teacher/weike/25L634e/1570711647.1271.57821.1571.docx",
 *      "resource_id": 1571,
 *      "prefix": "bj.bcebos.com",
 *      "bucket": "umu-pd",
 *      "timestamp": 1570711647
 *   }
 * }
 */
var request = require('./request');
var logger = require('./logger');

function getUploadObj(params) {
    return request
        .get(
            '/uapi/v1/ufs/get-upload-obj',
            Object.assign(
                {
                    id_prefix: 'teacher',
                },
                params
            )
        )
        .then(function (response) {
            return response && response.data;
        });
}

/**
 * @sp	是	int，服务提供商 1. 百度 2. AWS
 * @resource_id	否	资源ID
 * @media_type string, 资源类型
 * @file_name	是	string, 文件名
 * @file_size	是	int, 文件大小
 * @path	是	string, 资源路径
 * @ext	是	文件后缀名
 * @extend_info	否	json, 扩展信息

 * @return { "error_code": 0, "error_message": "", "data": { "result": 1, "resource_id": "1474" }}
 */

function uploadCallback(params) {
    return request.get('/uapi/v1/ufs/upload-callback', params).then(function (response) {
        return response && response.data;
    }).catch(function (e) {
        logger.error('[umu-upload] uploadCallback error:', e, params);
        throw e;
    });
}

function assumerole(region) {
    var params = {};
    if (region) {
        params = { region: region };
    }
    return request.get('/napi/aws/assumerole', params).then(function (response) {
        // 网络错误会导致response为undefined，这块是否需要增加重试机制？
        return response && response.data;
    }).catch(function (e) {
        logger.error('[umu-upload] assumerole error:', e, params);
        throw e;
    });
}

function isInWhiteList() {
    const params = { type: 2 };
    return request.get('/uapi/v1/user/in-white-list', params).then(function (response) {
        return response && response.data;
    }).catch(function (e) {
        logger.error('[umu-upload] isInWhiteList error:', e, params);
        throw e;
    });
}

module.exports = {
    getUploadObj: getUploadObj,
    uploadCallback: uploadCallback,
    assumerole: assumerole,
    isInWhiteList: isInWhiteList,
};
